<template lang="html">
  <div id="automatic-recharge-edit">
    <a
      class="link"
      href="#"
      @click.prevent="openEditAutomaticRechargeModal()">
      Editar
    </a>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="editAutomaticRechargeModal"
      ref="editAutomaticRechargeModal"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-lg modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Editar Recarga Automática</h5>
            <button
              type="button"
              class="close"
              @click.prevent="closeEditAutomaticRechargeModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <div
              v-if="error"
              class="alert alert-danger"
              role="alert">
              <span v-html="error.message" />
            </div>
            <div class="form-group">
              <h5>Informe um <b>valor mínimo</b> para a recarga automática</h5>
            </div>
            <div class="form-group row">
              <div class="col-sm-12 minimumAmount automaticRechargeAmount">
                <div class="input-group">
                  <span class="input-group-prepend">
                    <label class="input-group-text">R$</label>
                  </span>
                  <input
                    class="form-control minimumAmount"
                    ref="minimumAmount"
                    type="number"
                    min="5"
                    max="50000"
                    step="1"
                    v-model.number="minimumAmountNumber"
                    @keydown.enter="automaticRechargeEdit"
                    required>
                  <span class="input-group-append">
                    <label class="input-group-text">,00</label>
                  </span>
                </div>
              </div>
            </div>
            <div class="form-group">
              <h5>Informe o <b>valor</b> que deseja recarregar</h5>
            </div>
            <div class="form-group row">
              <div class="col-sm-12 rechargeAmount automaticRechargeAmount">
                <div class="input-group">
                  <span class="input-group-prepend">
                    <label class="input-group-text">R$</label>
                  </span>
                  <input
                    class="form-control rechargeAmount"
                    ref="rechargeAmount"
                    type="number"
                    min="20"
                    max="50000"
                    step="1"
                    v-model.number="rechargeAmountNumber"
                    @keydown.enter="automaticRechargeEdit"
                    required>
                  <span class="input-group-append">
                    <label class="input-group-text">,00</label>
                  </span>
                </div>
              </div>
            </div>
            <div>
              <div class="form-group">
                <h3>Ou selecione o <b>desconto</b> deseja receber</h3>
              </div>
              <div class="form-group row">
                <div :class="`col automaticRechargeSliderEdit`">
                  <div
                    class="range-slider"
                    @click.prevent="sliderClick">
                    <input
                      class="form-control"
                      id="automaticRechargeSliderEdit"
                      type="input"
                      data-slider-tooltip="hide"
                      :data-slider-ticks-snap-bounds="sliderTicksSnapBounds"
                      :data-slider-ticks-labels="sliderTicksLabels"
                      :data-ticks_positions="sliderTicksPositions">
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="col-lg-6"><h5>Minuto Móvel</h5></div>
                  <div class="col-lg-6"><h5>Minuto Fixo</h5></div>
                </div>
                <div class="row">
                  <div class="col-sm-6"><h2>R$ {{ mobilePrice }}</h2></div>
                  <div class="col-sm-6"><h2>R$ {{ fixedlinePrice }}</h2></div>
                </div>
              </div>
              <div>
                <h5 v-if="rechargeAmountNumber >= 500">
                  Com esse desconto a cada <b>1000 minutos</b> você economizará em média <b>R$ {{ averageSaving }},00</b>
                </h5>
              </div>
            </div>
            <hr>
            <div>
              <span>Após a compensação, seus créditos serão adicionados automaticamente.</span><br>
              <span>Os pagamentos realizados com cartão de crédito têm a compensação quase sempre instantânea.</span><br>
              <span>Não salvamos os dados sensíveis do seu cartão de crédito.</span>
            </div>
          </div>

          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-outline-secondary"
                @click.prevent="closeEditAutomaticRechargeModal">Cancelar</button>
              <button
                type="button"
                class="btn btn-primary"
                :disabled="(error && error.message) ||
                (!rechargeAmountNumber || !minimumAmountNumber)"
                @click.prevent="automaticRechargeEdit">Alterar Recarga Automática</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loopback from '@/services/loopback'
import { EventBus } from '@/services/event-bus'
const MOBILE_PRICES = ['0,35', '0,33', '0,30', '0,25', '0,19', '0,12']
const MOBILE_AVERAGE_SAVINGS = [0, 18, 53, 105, 158, 228]
const FIXEDLINE_PRICES = ['0,08', '0,079', '0,078', '0,076', '0,074', '0,07']
const FIXEDLINE_AVERAGE_SAVINGS = [0, 1, 2, 4, 6, 10]
const CHARGE_AMOUNTS = [200, 500, 1000, 2000, 3000, 5000]
const CHARGE_AMOUNT_TIERS = [0, 5, 15, 30, 45, 65]
const CHARGE_AMOUNT_POSITIONS = [0, 20, 40, 60, 80, 100]

export default {
  name: 'AutomaticRechargeEdit',
  props: {
    id: {
      type: Number,
      default: 1
    },
    minimumAmount: {
      type: String,
      default: '20,00'
    },
    rechargeAmount: {
      type: String,
      default: '100,00'
    }
  },
  data () {
    return {
      sliderTicks: CHARGE_AMOUNT_POSITIONS,
      sliderTicksPositions: CHARGE_AMOUNT_POSITIONS,
      sliderTicksLabels: CHARGE_AMOUNT_TIERS.map(v => `${v}%`),
      sliderTicksSnapBounds: 20,
      error: null,
      minimumAmountNumber: null,
      rechargeAmountNumber: null
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.minimumAmountNumber = this.parseAmountToNumber(this.minimumAmount)
      this.rechargeAmountNumber = this.parseAmountToNumber(this.rechargeAmount)
      this.buildSlider()
    })
  },
  methods: {
    automaticRechargeEdit () {
      const payload = {
        minimumAmount: this.minimumAmountNumber,
        rechargeAmount: this.rechargeAmountNumber
      }
      loopback.patch(`/automatic-recharges/${this.id}`, payload)
        .then(() => {
          this.error = null
          this.closeEditAutomaticRechargeModal()
          EventBus.$emit('reload-automatic-recharge')
          EventBus.$emit('automatic-recharge-success')
        })
        .catch(err => {
          if (err.message && err.message.includes('has the same values')) {
            this.error = {
              message: 'Os valores informados são iguais aos atuais.'
            }
            return
          }
          const errorMessages = err.message.split(';')
          if (!errorMessages) {
            this.error = {
              message: [
                'Infelizmente tivemos um problema ao gerar sua recarga automática,',
                '<a href="https://wa.me/+554833328503" target="_blank" class="link">clique aqui e fale com nosso suporte via WhatsApp!</a>'
              ].join(' ')
            }
          }
          if (errorMessages.length > 1) {
            this.error = {
              message: errorMessages.join('<br>')
            }
          } else {
            this.error = {
              message: err.message
            }
          }
        })
    },
    getAmountByPosition (position) {
      return CHARGE_AMOUNTS[CHARGE_AMOUNT_POSITIONS.findIndex(v => parseInt(v) === parseInt(position))]
    },
    getPositionByAmount (amount) {
      const positionIndex = CHARGE_AMOUNTS.reduce((findIndex, tier, index) => {
        if (parseInt(amount) >= parseInt(tier)) {
          findIndex = index
        }
        return findIndex
      }, 0)
      return positionIndex
    },
    getAmountPositionByAmount (amount) {
      return CHARGE_AMOUNT_POSITIONS[this.getPositionByAmount(amount)]
    },
    buildSlider () {
      $(`#automaticRechargeSliderEdit`).slider({
        value: this.getAmountPositionByAmount(this.rechargeAmountNumber),
        ticks: this.sliderTicks,
        ticks_positions: this.sliderTicksPositions,
        ticks_labels: this.sliderTicksLabels,
        ticks_snap_bounds: this.sliderTicksSnapBounds
      }).on('slide', (slideEvt) => {
        this.rechargeAmountNumber = this.getAmountByPosition(slideEvt.value)
      })
    },
    sliderClick () {
      this.rechargeAmountNumber = this.getAmountByPosition($(`#automaticRechargeSliderEdit`)[0].value)
    },
    openEditAutomaticRechargeModal () {
      $(this.$refs.editAutomaticRechargeModal).modal('show')
    },
    closeEditAutomaticRechargeModal () {
      $(this.$refs.editAutomaticRechargeModal).modal('hide')
      if (this.lastRecharge) {
        this.minimumAmount = Number(this.lastRecharge.minimumAmount.split(',')[0])
        this.rechargeAmount = Number(this.lastRecharge.rechargeAmount.split(',')[0])
      }
    },
    parseAmountToNumber (amount) {
      amount = amount.replace(/\./g, '').replace(',', '.')

      const amountParsed = Number(amount)
      if (isNaN(amountParsed)) {
        return amount
      }
      return amountParsed
    }
  },
  computed: {
    mobilePrice () {
      return MOBILE_PRICES[this.getPositionByAmount(this.automaticRechargeAmount)]
    },
    fixedlinePrice  () {
      return FIXEDLINE_PRICES[this.getPositionByAmount(this.automaticRechargeAmount)]
    },
    averageSaving () {
      return MOBILE_AVERAGE_SAVINGS[this.getPositionByAmount(this.automaticRechargeAmount)] + FIXEDLINE_AVERAGE_SAVINGS[this.getPositionByAmount(this.automaticRechargeAmount)]
    }
  },
  watch: {
    minimumAmountNumber () {
      this.error = null
    },
    rechargeAmountNumber (amount) {
      $(`#automaticRechargeSliderEdit`).slider('setValue', this.getAmountPositionByAmount(amount))
      this.error = null
    }
  }
}
</script>

<style lang="scss">
#automatic-recharge-edit {
  float: left;
}
.automaticRechargeAmount {
  text-align: center;
}
.automaticRechargeAmount .input-group {
  max-width: 250px;
  margin: auto;
}
.automaticRechargeAmount .input-group {
  input {
    text-align: right;
    height: 35px;
    font-size: large;
  }
  .input-group-prepend label {
    height: 35px;
    font-size: large;
  }
  .input-group-append label {
    height: 35px;
    font-size: large;
  }
}
.slider.slider-horizontal {
  width: 90% !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/AutomaticRecharge/Edit.vue